import { useEffect, useState } from 'react';

import { initializeTranslation } from '@/i18n';

export const useInitializeTranslation = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    void initializeTranslation().then(() => {
      if (active) {
        setReady(true);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return ready;
};
